export default __webpack_public_path__ + "6f9d04b1a459ac355f03b91c36d68ac1.png";